import React from 'react';
import { Redirect, Link } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.css';
import '../../assets/css/style.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from 'jquery';

import RegistryTable from '../shared/RegistryTable_RT.jsx';
import ConfirmActionModal from '../shared/ConfirmActionModal.jsx';
import AddCustomContentModal from '../shared/AddCustomContentModal';
// import SearchBlock from '../shared/SearchBlock';

import * as api from '../../api/api';

class CustomContentFilePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      selectedObjectId: 0,
      isUserAdmin: api.isUserAdmin(),
    };

    this.processGetDataPromise = this.processGetDataPromise.bind(this);

    this.handleAddAction = this.handleAddAction.bind(this);
    this.handleConfirmDeleteAction = this.handleConfirmDeleteAction.bind(this);

    this.handleRowClick = this.handleRowClick.bind(this);
    this.updateMarkers = this.updateMarkers.bind(this);

    // this.handleSearchButtonClick = this.handleSearchButtonClick.bind(this);

    this.tableColumns = [
      {
        Header: '_id',
        accessor: 'id',
      },
      {
        Header: '#',
        accessor: 'number',
      },
      {
        Header: 'Имя файла',
        accessor: 'fileName',
      },
      {
        Header: 'Тип',
        accessor: 'type',
      },
    ];
  }

  componentDidMount() {
    if (!api.isUserAdmin()) {
      this.setState({
        redirectUrl: '/users/permission-denied',
        needRedirect: true,
      });

      return;
    }

    this.processGetDataPromise(api.getCustomContentFiles());

    // api.getDisplays().then(
    //     (response) => {

    //         this.mapMarkers = response.data.data.map((item, i) => {
    //             return {
    //                 id: item.id,
    //                 title: item.name,
    //                 coordinates: [item.latitude, item.longitude]
    //             }
    //         });

    //         this.setState({
    //             displays: response.data.data.map((item, i) => {
    //                 return {
    //                     id: item.id,
    //                     number: i + 1,
    //                     name: item.name,
    //                     description: item.description,
    //                     latitude: utils.formatDouble(item.latitude),
    //                     longitude: utils.formatDouble(item.longitude),
    //                     checkpointName: item.checkpointName,
    //                     isEnabled: item.isEnabled
    //                 }
    //             })
    //         });

    //         this.props.updateLoader({
    //             loaded: true,
    //             message: ""
    //         });
    //     },
    //     (error) => {
    //         this.props.updateLoader({
    //             loaded: true,
    //             message: "Ошибка при получении данных: " + error
    //         });
    //     }
    // );
  }

  updateMarkers(start, end) {
    this.setState({
      selectedObjectId: 0,
    });
  }

  handleRowClick(id) {
    this.setState({
      selectedObjectId: id,
      fileName: this.state.data.find((item) => item.id == id).fileName,
    });
  }

  handleAddAction() {
    $('#addCustomContentModal ').modal(null);
  }

  handleConfirmDeleteAction() {
    this.props.updateLoader({
      loaded: false,
      message: '',
    });

    api
      .makeRequest(api.removeCustomContentFile(this.state.selectedObjectId))
      .then(
        (response) => {
          for (let i = 0; i < this.state.data.length; i++) {
            if (this.state.selectedObjectId === this.state.data[i].id) {
              let copy = this.state.data.slice();
              copy.splice(i, 1);

              this.setState({
                data: copy,
              });
            }
          }

          this.props.updateLoader({
            loaded: true,
            message: '',
          });
        },
        (error) => {
          this.props.updateLoader({
            loaded: true,
            message: 'Ошибка при выполнении действия: ' + error,
          });
        },
      );
  }

  processGetDataPromise(promise) {
    this.props.updateLoader({
      loaded: false,
      message: '',
    });

    api.makeRequest(promise).then(
      (response) => {
        this.setState({
          data: response.data.data.map((item, i) => {
            return {
              id: item.id,
              number: i + 1,
              fileName: item.name,
              type: item.type,
            };
          }),
        });

        this.props.updateLoader({
          loaded: true,
          message: '',
        });
      },
      (error) => {
        this.props.updateLoader({
          loaded: true,
          message: 'Ошибка при получении данных: ' + error,
        });
      },
    );
  }

  // handleSearchButtonClick(searchValue) {
  //     this.processGetDataPromise(api.searchDisplays(searchValue));
  // }

  render() {
    if (this.state.redirectUrl) {
      return <Redirect to={this.state.redirectUrl} />;
    }

    return (
      <div className="d-flex justify-content-between">
        <div className="flex-grow-1">
          {/* <SearchBlock
                        placeholder="Введите часть названия или описания..."
                        handleSearchButtonClick={this.handleSearchButtonClick}
                    /> */}
          <div className="mt-4">
            <RegistryTable
              columns={this.tableColumns}
              data={this.state.data}
              showActions={this.state.isUserAdmin}
              onRowClick={this.handleRowClick}
              onAddAction={this.handleAddAction}
              onPageChange={(start, end) => this.updateMarkers(start, end)}
            />
          </div>
          <div className="mt-4">
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary-custom btn-with-link"
                disabled={this.state.selectedObjectId === 0}
              >
                <Link
                  to={
                    this.state.selectedObjectId === 0
                      ? '#'
                      : '/custom-content/' +
                        this.state.selectedObjectId +
                        '/show?return_url=/custom-content'
                  }
                >
                  <FontAwesomeIcon
                    icon="play"
                    size="sm"
                    color="#fff"
                    className="mr-2"
                  />
                  Запустить отображение
                </Link>
              </button>

              <button
                className="btn btn-primary-custom btn-with-link ml-3"
                disabled={this.state.selectedObjectId === 0}
              >
                <Link
                  to={
                    this.state.selectedObjectId === 0
                      ? '#'
                      : '/custom-content/' +
                        this.state.selectedObjectId +
                        '/assignment?return_url=/custom-content'
                  }
                >
                  <FontAwesomeIcon
                    icon="list"
                    size="sm"
                    color="#fff"
                    className="mr-2"
                  />
                  Редактировать привязку
                </Link>
              </button>
            </div>
          </div>
        </div>
        <ConfirmActionModal onConfirm={this.handleConfirmDeleteAction} />
        <AddCustomContentModal
          updateLoader={this.props.updateLoader}
          onSuccess={() =>
            this.processGetDataPromise(api.getCustomContentFiles())
          }
        />
      </div>
    );
  }
}

export default CustomContentFilePage;
